import React from 'react';
import Badge from './Badge';
import { caseStudies } from '../data/caseStudies';

const CaseStudies = () => {
  return (
    <section id="case-studies" className="section-padding bg-white">
      <div className="container-xl">
        <div className="text-center mb-20">
          <p className="text-sm font-semibold text-slate-600 uppercase tracking-wide mb-4">
            Case Studies
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl logo-font text-gray-900 mb-6">
            Real Results for Real Businesses
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-slate-800 to-slate-600 mx-auto rounded-full mb-8"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            See how we've helped businesses transform their operations with our custom solutions.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-8 xl:gap-10 2xl:gap-12 max-w-fit">
            {caseStudies.map((study, index) => (
            <div
              key={study.id}
              className="group bg-white rounded-3xl border border-neutral-200/60 shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden hover:-translate-y-3"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {/* Image Placeholder */}
              <div className="h-48 bg-gradient-to-br from-indigo-100 to-blue-100 flex items-center justify-center relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/20 to-blue-500/20"></div>
                <div className="relative z-10 text-center">
                  <div className="w-16 h-16 bg-white/80 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <p className="text-sm font-medium text-indigo-700">Case Study</p>
                </div>
                
                {/* Category Badge */}
                <div className="absolute top-4 left-4">
                  <Badge variant="success" size="sm">
                    {study.category}
                  </Badge>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-indigo-600 transition-colors duration-300">
                  {study.title}
                </h3>
                
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {study.description}
                </p>

                <ul className="space-y-2 mb-6">
                  {study.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start space-x-3">
                      <div className="w-1.5 h-1.5 bg-indigo-600 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <button className="w-full inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-indigo-600 border border-indigo-200 hover:bg-indigo-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                  <span>See Details</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl border border-neutral-200/60 shadow-sm p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Want to See More Results?
            </h3>
            <p className="text-gray-600 mb-6">
              We have dozens of successful projects across various industries. Let's discuss how we can help your business.
            </p>
            <button
              onClick={() => {
                const element = document.querySelector('#contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              Schedule a Demo
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
